//
export default [
  {
    path: "/civicismKind",
    component: () => import("../pages/spaceLocation/civicismKind/civicismKind.vue"),
    name: 'civicismKind',
    title: "市政类",
    meta: {
      title: "市政类"
    }
  },
  {
    path: "/dwellingKind",
    component: () => import("../pages/spaceLocation/dwellingKind/dwellingKind.vue"),
    name: "dwellingKind",
    title: "住宅类",
    meta: {
      title: "住宅类"
    }
  },
  {
    path: "/commonKind",
    component: () => import("../pages/spaceLocation/commonKind/commonKind.vue"),
    name: "commonKind",
    title: "公区类",
    meta: {
      title: "公区类"
    }
  }
]
